import { SET_GRAPHQL_ERRORS, SET_NETWORK_ERROR } from './action-types'

export const GraphQLErrors = (error, operation) => {
  return {
    type: SET_GRAPHQL_ERRORS,
    error: error,
    operation: operation
  }
}

export const NetworkError = (error, operation) => {
  return {
    type: SET_NETWORK_ERROR,
    error: error,
    operation: operation
  }
}



// WEBPACK FOOTER //
// ./src/actions/error-actions.js